// tslint:disable jsx-no-lambda
import * as classNames from "classnames";
import * as React from "react";
import { connect } from "react-redux";
import { bindActionCreators, Dispatch } from "redux";
import { alertSettingsActions, globalActions } from "src/actions";

import { IProps } from "@blueprintjs/core";

import { SettingsControlProperty } from '../components';

import { DuoButtons, ToggleButtons } from 'src/components';

import { MPDHiddenScrollContainer } from 'src/mpd-library';

import "./styles.css";

interface ISocialSettingsEditProps extends IProps {
  accountType: string;
  routeProps: any;
  channels?: any;
  onCancelChanges: (pathname: string, history: any) => (dispatch: Dispatch<any>) => Promise<void>;
  onSaveChanges: (alertSettingsType: string, channels: any, pathname: string, history: any) => (dispatch: Dispatch<any>) => Promise<void>;
  onUpdateToolBar: (
    topBarProps: any
  ) => (dispatch: Dispatch<any>) => Promise<void>;
  onCloseRightPanel?(): void;
  onToggleRightPanel?(): void;
}

interface ISocialSettingsEditState {
  channels: any;
  accountToEdit?: any;
}

class SocialSettingsEdit extends React.Component<ISocialSettingsEditProps, ISocialSettingsEditState> {
  constructor(props: ISocialSettingsEditProps) {
    super(props);
    this.onSaveChanges = this.onSaveChanges.bind(this);
    this.onCancelChanges = this.onCancelChanges.bind(this);
    this.initialize = this.initialize.bind(this);
    this.onChangeSocialAccountProperty = this.onChangeSocialAccountProperty.bind(this);
    const { channels } = this.props;
    this.state = {
        channels
    }
  }

  public componentDidMount() {
    this.initialize(this.props);
  }

  public componentWillReceiveProps(nextProps: ISocialSettingsEditProps) {
    if(nextProps.routeProps !== this.props.routeProps) {
      this.initialize(nextProps);
    }
  }
  
  public render() {
    const { className } = this.props;
    const { accountToEdit } = this.state;

    return (
      <MPDHiddenScrollContainer yDirection={true} className={classNames('social-settings-edit-container', className)}>
       <SettingsControlProperty
            title='Pre-Selected' 
            subtitle='When you select Facebook as a channel, this account will be pre-selected as on.' 
            switchProps={{
               checked: accountToEdit ? accountToEdit.preSelected : false,
               onChange: e => this.onChangeSocialAccountProperty(e, 'preSelected')
            }}
        />
        <SettingsControlProperty
            title='Track Likes' 
            subtitle='Tracking likes provides an additional layer of analytics beyond total reach.' 
            switchProps={{
                checked: accountToEdit ? accountToEdit.trackLikes : false,
                onChange: e => this.onChangeSocialAccountProperty(e, 'trackLikes')
            }}
        />
        <SettingsControlProperty
            title='Deactivate Account' 
            subtitle='Deactivating accont will remove it as an option when you are composing an alert.' 
            switchProps={{
                checked: accountToEdit ? !accountToEdit.active : false,
                onChange: e => this.onChangeSocialAccountProperty(e, 'active')
            }}
        />
      </MPDHiddenScrollContainer>
    );
  }

    private onChangeSocialAccountProperty(event: React.FormEvent<HTMLInputElement>, detailToChange: string) {
        const { accountToEdit } = this.state;
        accountToEdit[detailToChange] = !accountToEdit[detailToChange];
        this.setState({ accountToEdit });
        // this.props.onChangeSocialAccountProperty(accountType, accountToEdit.id, detailToChange);
    }

    private updateToolBar(text: string) {
        const topBarProps = {
            leftElement: (
                <ToggleButtons
                label={text.charAt(0).toUpperCase() + text.slice(1)}
                onToggle={this.props.onToggleRightPanel}
                onClose={this.props.onCloseRightPanel}
                />
            ),
            rightElement: (
                <DuoButtons
                    firstButtonClick={this.onCancelChanges}
                    secondButtonClick={this.onSaveChanges}
                    firstButtonText="Cancel"
                    secondButtonText="Save"
                />
            )
        };
        if(this.props.onUpdateToolBar){
        this.props.onUpdateToolBar(topBarProps);
        }
    }

    private onCancelChanges(event: any)  {
        const { accountType, routeProps } = this.props;
        const { history } = routeProps;
        const pathname = `/alerts-settings/${accountType}`;
        this.props.onCancelChanges(pathname, history);
    }

    private onSaveChanges(event: any) {
        const { onSaveChanges, accountType, routeProps } = this.props;
        if(onSaveChanges){
            const { history } = routeProps;
            const { channels, accountToEdit } = this.state;
            const list = channels[accountType].list;
            const index = list.findIndex((listItem:any) => listItem.id === accountToEdit.id );
            list[index] = accountToEdit;
            const pathname = `/alerts-settings/${accountType}`;
            onSaveChanges('channels', channels, pathname, history);
        }
    }

    private initialize(props: any) {
        const { accountType, channels, routeProps } = props;
        const pathname = this.props.routeProps.history.location.pathname;
        const pathArr = pathname.split('/');
        const accountId = pathArr[pathArr.length -1];
        const accountToEdit = alertSettingsActions.onGetAccount(accountType, accountId, channels);
        if(accountToEdit === null){
            routeProps.history.push('/alerts-settings/' + accountType);
        }
        else {
            this.setState({ accountToEdit }); 
            const text = accountType + ' / ' + accountToEdit.id;
            this.updateToolBar(text);
        }
    }
}

const mapStateToProps = (state: any) => {
    const {  alertSettings } = state;
    const { channels } = alertSettings;
    const { accountToEdit } = channels;
    return {
        accountToEdit,
        channels
    };
};

const mapDispatchToProps = (dispatch: Dispatch<any>) => {
    return {
        onUpdateToolBar: bindActionCreators(
            globalActions.onUpdateToolBar,
            dispatch
        ),
        getAccount: bindActionCreators(
            alertSettingsActions.onGetAccount,
            dispatch
        ),
        onSaveChanges: bindActionCreators(
            alertSettingsActions.onSaveChanges,
            dispatch
        ),
        onCancelChanges: bindActionCreators(
            alertSettingsActions.onCancelChanges,
            dispatch
        ),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(SocialSettingsEdit);



// WEBPACK FOOTER //
// ./src/controllers/alert-settings/social-settings-edit/social-settings-edit.tsx